export default __webpack_public_path__ + "static/media/IconFB.49ee3962.svg";